import { render, staticRenderFns } from "./AssetLayoutChoiceMultiselect.vue?vue&type=template&id=a8b1f494&"
import script from "./AssetLayoutChoiceMultiselect.vue?vue&type=script&lang=js&"
export * from "./AssetLayoutChoiceMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports